import React, { useState ,useEffect } from "react";
import { X } from "lucide-react";
import { sendQuotationEmail } from "../services/emailService";
import Swal from 'sweetalert2';

export default function RequestQuotationModal({
  isOpen,
  onClose,
  productName = "",
}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    countryCode: "+91",
    productName: productName,

  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const countries = [
    { name: "India", code: "+91", flag: "🇮🇳" },
    { name: "Algeria", code: "+213", flag: "🇩🇿" },
    { name: "Argentina", code: "+54", flag: "🇦🇷" },
    { name: "Australia", code: "+61", flag: "🇦🇺" },
    { name: "Austria", code: "+43", flag: "🇦🇹" },
    { name: "Bahrain", code: "+973", flag: "🇧🇭" },
    { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
    { name: "Belgium", code: "+32", flag: "🇧🇪" },
    { name: "Brazil", code: "+55", flag: "🇧🇷" },
    { name: "Canada", code: "+1", flag: "🇨🇦" },
    { name: "Chile", code: "+56", flag: "🇨🇱" },
    { name: "China", code: "+86", flag: "🇨🇳" },
    { name: "Colombia", code: "+57", flag: "🇨🇴" },
    { name: "Denmark", code: "+45", flag: "🇩🇰" },
    { name: "Egypt", code: "+20", flag: "🇪🇬" },
    { name: "Finland", code: "+358", flag: "🇫🇮" },
    { name: "France", code: "+33", flag: "🇫🇷" },
    { name: "Germany", code: "+49", flag: "🇩🇪" },
    { name: "Greece", code: "+30", flag: "🇬🇷" },
    { name: "Hong Kong", code: "+852", flag: "🇭🇰" },
    { name: "Indonesia", code: "+62", flag: "🇮🇩" },
    { name: "Ireland", code: "+353", flag: "🇮🇪" },
    { name: "Israel", code: "+972", flag: "🇮🇱" },
    { name: "Italy", code: "+39", flag: "🇮🇹" },
    { name: "Japan", code: "+81", flag: "🇯🇵" },
    { name: "Malaysia", code: "+60", flag: "🇲🇾" },
    { name: "Mexico", code: "+52", flag: "🇲🇽" },
    { name: "Netherlands", code: "+31", flag: "🇳🇱" },
    { name: "New Zealand", code: "+64", flag: "🇳🇿" },
    { name: "Nigeria", code: "+234", flag: "🇳🇬" },
    { name: "Norway", code: "+47", flag: "🇳🇴" },
    { name: "Pakistan", code: "+92", flag: "🇵🇰" },
    { name: "Philippines", code: "+63", flag: "🇵🇭" },
    { name: "Poland", code: "+48", flag: "🇵🇱" },
    { name: "Portugal", code: "+351", flag: "🇵🇹" },
    { name: "Qatar", code: "+974", flag: "🇶🇦" },
    { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
    { name: "Singapore", code: "+65", flag: "🇸🇬" },
    { name: "South Africa", code: "+27", flag: "🇿🇦" },
    { name: "South Korea", code: "+82", flag: "🇰🇷" },
    { name: "Spain", code: "+34", flag: "🇪🇸" },
    { name: "Sri Lanka", code: "+94", flag: "🇱🇰" },
    { name: "Sweden", code: "+46", flag: "🇸🇪" },
    { name: "Switzerland", code: "+41", flag: "🇨🇭" },
    { name: "Taiwan", code: "+886", flag: "🇹🇼" },
    { name: "Thailand", code: "+66", flag: "🇹🇭" },
    { name: "Turkey", code: "+90", flag: "🇹🇷" },
    { name: "UAE", code: "+971", flag: "🇦🇪" },
    { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
    { name: "United States", code: "+1", flag: "🇺🇸" },
    { name: "Vietnam", code: "+84", flag: "🇻🇳" },
  ];

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      productName: productName,
    }));
  }, [productName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await sendQuotationEmail(formData);
    setFormSubmitted(true);

    Swal.fire({
      icon: 'success',
      title: 'Request Sent!',
      text: 'Your quotation request has been sent successfully.',
      confirmButtonColor: '#73340E',
    });

    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        mobile: "",
        countryCode: "+91",
        productName: productName,
      });
      setFormSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error("Email send error:", error.message);
    Swal.fire({
      icon: 'error',
      title: 'Oops!',
      text: 'Something went wrong. Please try again later.',
      confirmButtonColor: '#73340E',
    });
  }
};

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#FBF1EB] rounded-lg w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#34302B] hover:text-[#73340E]"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        <div className="p-6">
          <h2 className="text-3xl font-serif text-center text-[#34302B] mb-6">
            Request Quotation
          </h2>

          <form
            onSubmit={handleSubmit}
            className="border border-[#C19775] rounded-lg p-6"
          >
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                E-mail ID
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="mobile"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                Mobile Number
              </label>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-0">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      countryCode: e.target.value,
                    }))
                  }
                  className="w-full sm:w-auto px-3 py-2 bg-gray-200 rounded sm:rounded-l sm:rounded-r-none border-r-0 text-[#34302B] text-sm"
                  style={{ minWidth: '90px' }}
                >
                  {countries.map((c, index) => (
                    <option key={`${c.code}-${index}`} value={c.code}>
                      {c.flag} {c.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter mobile number"
                  required
                  pattern="[0-9]{10}"
                  className="flex-1 bg-gray-200 rounded sm:rounded-r sm:rounded-l-none p-2 text-[#34302B]"
                />
              </div>
              <p className="text-xs text-gray-600 mt-1">Enter 10-digit mobile number</p>
            </div>

            <div className="mb-4">
              <label
                htmlFor="productName"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                Product Name
              </label>
              <input
                type="text"
                id="productName"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>


            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-[#73340E] hover:bg-[#C09670] text-white px-8 py-2 rounded"
              >
                {formSubmitted ? "Request Sent!" : "Submit Request"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
